var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.exportData.length > 0
    ? _c("sidebar-widget", {
        staticClass: "sidebar-export",
        attrs: {
          id: "export-widget",
          title: _vm.$gettext("Export"),
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _c(
                    "form",
                    {
                      staticClass: "sidebar-export",
                    },
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: "export",
                          size: 16,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.url,
                            title: _vm.title,
                          },
                          on: {
                            click: function click($event) {
                              $event.preventDefault()
                              return _vm.createExport()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.title))]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          2505773419
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }